<div
  class="page-cover"
  [style.background]="bgImage"
  [style.backgroundSize]="'cover'"
></div>
<div class="page-filter" [style.opacity]="bgFilterOpacity"></div>
<div class="content" [class.mat-elevation-z8]="true">
  <mat-card style="height: 400px">
    <mat-card-content>
      <div
        fxLayout="column"
        fxLayoutAlign="start center"
        class="accent-text-color"
      >
        <div
          style="
            font-size: 26px;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 50px;
          "
        >
          {{ 'key_wentWrong' | translate }}
        </div>
        <mat-icon fxFlex="none" style="font-size: 200px; margin-left: -200px"
          >web</mat-icon
        >
        <mat-icon
          fxFlex="none"
          style="font-size: 80px; margin-left: 160px; margin-top: -50px"
          >error_outline</mat-icon
        >
        <div
          fxFlex="none"
          fxLayout="row"
          fxLayoutAlign="start center"
          style="margin-top: 220px; width: 100%"
        >
          <div
            *ngIf="errorMessage"
            style="
              margin-top: 16px;
              padding: 6px 10px;
              color: white;
              border-radius: 4px;
            "
            class="warn-bg-color"
          >
            {{ errorMessage | translate }}
          </div>
          <div fxFlex="auto"></div>
          <button
            mat-stroked-button
            color="primary"
            style="margin-top: 15px"
            (click)="onReturnToStart()"
          >
            {{ 'l10n_returnToStart' | translate }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
